import React from 'react'
import styled from 'styled-components/macro';
import Media from "react-media";

const Container = styled.div`
    background-color: #F3F2F1;
    height: 25.2rem;
    display: flex;
    /* align-content: center; */
    flex-direction: column;
    justify-content: space-evenly;
    margin: 40px 0;
    @media screen and (max-width: 768px) {
        height: 61.5rem;
        justify-content: start;
    }
`;

const Title = styled.div`
    font-size: 2.4rem;
    font-family: 'Montserrat';
    font-weight: 700;
    text-align: center;
    @media screen and (max-width: 768px) {
        font-size: 1.8rem;
        margin-top: 3rem;
    }
`;

const ReasonsContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    font-family: 'Montserrat';
    align-items: baseline;
    @media screen and (max-width: 768px) {
        flex-direction: column;
        align-items: center;
        justify-content: space-around;
        height: 100%;
        margin: 5rem 0;
    }
`;

const Reason = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    @media screen and (max-width: 768px) {
    }
`;

const ReasonNumber = styled.div`
    font-size: 3.6rem;
    font-weight: 400;
    font-family: 'Montserrat';
    text-align: center;
    height: 4.4rem;
    width: 22.6rem;
    color: #000000;
`;

const ReasonText = styled.div`
    font-size: 1.6rem;
    font-weight: 400;
    color: #333333;
    font-family: 'Montserrat';
    text-align: center;
    width: 22.6rem;
    line-height: 2rem;
`;

const Separation = styled.hr`
    height: 4.5rem;
    width: 1px;
    color: #979797;
    margin: auto 0 ;
    @media screen and (max-width: 768px) {
        transform: rotate(90deg);
    }
`;

export default () => {
    return (
        <Container>
            <Title>Pourquoi rejoindre BazarChic ?</Title>
            <ReasonsContainer>
                <Reason>
                    <ReasonNumber>14</ReasonNumber>
                    <ReasonText>nouvelles ventes sélectionnées avec soin</ReasonText>
                </Reason>
                <Separation />
                <Reason>
                    <ReasonNumber>10€</ReasonNumber>
                    <Media query={{ minWidth: 769 }}>
                        <ReasonText>offerts sur la<br/> première commande<br/> avec le code BIENVENUE</ReasonText>
                    </Media>
                    <Media query={{ maxWidth: 768 }}>
                        <ReasonText>offerts sur la première<br/> commande avec le code<br/> BIENVENUE</ReasonText>
                    </Media>
                </Reason>
                <Separation />
                <Reason>
                    <ReasonNumber>+ 1000</ReasonNumber>
                    <ReasonText>marques premium</ReasonText>
                </Reason>
            </ReasonsContainer>
        </Container>

    )
}